/** @prettier */
//-----------------------------
//	サイトグラフ用データ作成処理
//-----------------------------
import * as apiIF from '../Type/api';
import {translateDate} from './graphFunction';
import {TFunction} from 'i18next';

/**
 * サイトグラフ用データ作成処理
 * @param {day|week|month|year} period グラフの期間
 * @param {apiIF.res.getStatesSitesBySiteID | null} siteData サイト単位状態データ
 * @param {string} timeZone タイムゾーン
 * @param {string} graphMode  グラフの表示モード(冷暖他orSL)
 * @param {string} graphStartDate  カレンダのスタート時間
 * @param {TFunction} trans  翻訳関数
 */
export const makeGraphDataSite = (
  period: string,
  siteData: apiIF.res.getStatesSitesBySiteID,
  timeZone: string,
  graphMode: string,
  graphStartDate: string,
  trans: TFunction
) => {
  let xArray = [];
  let powerConsumptionCoolYArray = [];
  let powerConsumptionHotYArray = [];
  let powerConsumptionOtherYArray = [];
  let powerConsumptionRTCoolYArray = [];
  let powerConsumptionRTHotYArray = [];
  let powerConsumptionAirConditioner = [];
  let powerConsumptionOtherEquipment = [];
  let dateFormat = 'HH'; /* グラフの軸表示フォーマット 初期値：1日 */
  let pickupDate: apiIF.resParameters.siteStatesData[] = [];

  /* データ無し時の初期値データを作成 */
  let iniData = [];
  for (let i = 0; i < 24; i++) iniData.push({hour: i});
  const retIni = {
    date: [],
    powerCool: [],
    powerHot: [],
    powerOther: [],
    powerRTCool: [],
    powerRTHot: [],
    powerAirConditioner: [],
    powerOtherEquipment: [],
  };

  /* グラフx軸ラベル */
  switch (period) {
    case 'day':
    default:
      dateFormat = 'HH:mm';
      break;
    case 'week':
      dateFormat = 'MMM.dd';
      break;
    case 'month':
      dateFormat = 'dd';
      break;
    case 'year':
      dateFormat = 'MMM.';
      break;
    case 'tenYear':
      dateFormat = 'yyyy';
      break;
  }

  if (siteData != null && siteData['states'].length > 0) {
    //siteData['states']のindex番号は終了日のデータが始まっているため逆順で格納する
    for (let data of siteData['states']) {
      pickupDate.push(data);
    }
    //グラフデータの先頭がグラフ取得開始日でない場合は、配列を反転する
    if (pickupDate[0].date !== graphStartDate) {
      pickupDate.reverse();
    }
    /* 消費電力グラフデータの作成 */
    /* グラフ関数へ渡すデータを作成する */
    for (let data of pickupDate) {
      /* 時間情報の追加 */
      xArray.push(translateDate(data['date'], timeZone, dateFormat, trans));
      /* データ部が存在するか確認 */
      if (
        data.hasOwnProperty('airconditioner') ||
        data.hasOwnProperty('qton') ||
        data.hasOwnProperty('hyozan') ||
        data.hasOwnProperty('hccvq') ||
        data.hasOwnProperty('chiller')
      ) {
        /* データが空欄でないか確認(空欄をグラフ化すると表示がバグる) */
        if (
          data.airconditioner['power-consumption'] !== undefined &&
          (data.airconditioner['power-consumption']['cooling-mode'] !== '' ||
            data.airconditioner['power-consumption']['heating-mode'] !== '' ||
            data.airconditioner['power-consumption']['other-mode'] !== '')
        ) {
          //空調機の冷房、暖房、その他の消費電力の合計を集計する
          if (graphMode === 'Aggregation') {
            //prettier-ignore
            powerConsumptionAirConditioner.push(
              Math.round(
                (Number(data.airconditioner['power-consumption']['cooling-mode']) +
                  Number(data.airconditioner['power-consumption']['heating-mode']) +
                  Number(data.airconditioner['power-consumption']['other-mode'])) / 1000
              )
            );
            //空調機の各消費電力を別々に集計する
          } else {
            //prettier-ignore
            powerConsumptionCoolYArray.push(
              Math.round(Number(data.airconditioner['power-consumption']['cooling-mode']) / 1000)
            );
            //prettier-ignore
            powerConsumptionHotYArray.push(
              Math.round(Number(data.airconditioner['power-consumption']['heating-mode']) / 1000)
            );
            //prettier-ignore
            powerConsumptionOtherYArray.push(
              Math.round(Number(data.airconditioner['power-consumption']['other-mode']) / 1000)
            );
          }
        } else {
          powerConsumptionCoolYArray.push(null);
          powerConsumptionHotYArray.push(null);
          powerConsumptionOtherYArray.push(null);
          powerConsumptionAirConditioner.push(null);
        }
        if (
          data.qton['power-consumption'] !== undefined &&
          data.hyozan['power-consumption'] !== undefined &&
          data.hccvq['power-consumption'] !== undefined &&
          data.chiller['power-consumption'] !== undefined
        ) {
          //RT機器の暖房と冷房の合計の消費電力を集計する
          if (graphMode === 'Aggregation') {
            //prettier-ignore
            powerConsumptionOtherEquipment.push(
              Math.round(
                (Number(data.qton['power-consumption']['heating-mode']) +
                  Number(data.chiller['power-consumption']['heating-mode']) +
                  Number(data.hyozan['power-consumption']['cooling-mode']) +
                  Number(data.hccvq['power-consumption']['cooling-mode']) +
                  Number(data.chiller['power-consumption']['cooling-mode'])) /1000
              )
            )
          }
          //RT機器の冷房の消費電力を集計する
          if (
            data.hyozan['power-consumption']['cooling-mode'] !== '' ||
            data.hccvq['power-consumption']['cooling-mode'] !== '' ||
            data.chiller['power-consumption']['cooling-mode'] !== ''
          ) {
            //prettier-ignore
            powerConsumptionRTCoolYArray.push(
              Math.round(
                (Number(data.hyozan['power-consumption']['cooling-mode']) +
                  Number(data.hccvq['power-consumption']['cooling-mode']) +
                  Number(data.chiller['power-consumption']['cooling-mode'])) / 1000
              )
            );
          } else {
            powerConsumptionRTCoolYArray.push(null);
          }
          //RT機器の暖房の消費電力を集計する
          if (
            data.qton['power-consumption']['heating-mode'] !== '' ||
            data.chiller['power-consumption']['heating-mode'] !== ''
          ) {
            //prettier-ignore
            powerConsumptionRTHotYArray.push(
              Math.round(
                (Number(data.qton['power-consumption']['heating-mode']) +
                  Number(data.chiller['power-consumption']['heating-mode'])) / 1000
              )
            );
          } else {
            powerConsumptionRTHotYArray.push(null);
          }
        } else {
          powerConsumptionRTCoolYArray.push(null);
          powerConsumptionRTHotYArray.push(null);
          powerConsumptionOtherEquipment.push(null);
        }
      } else {
        powerConsumptionCoolYArray.push(null);
        powerConsumptionHotYArray.push(null);
        powerConsumptionOtherYArray.push(null);
        powerConsumptionRTCoolYArray.push(null);
        powerConsumptionRTHotYArray.push(null);
        powerConsumptionAirConditioner.push(null);
        powerConsumptionOtherEquipment.push(null);
      }
    }

    const ret = {
      powerCool: powerConsumptionCoolYArray,
      powerHot: powerConsumptionHotYArray,
      powerOther: powerConsumptionOtherYArray,
      powerRTCool: powerConsumptionRTCoolYArray,
      powerRTHot: powerConsumptionRTHotYArray,
      powerAirConditioner: powerConsumptionAirConditioner,
      powerOtherEquipment: powerConsumptionOtherEquipment,
      date: xArray,
    };

    return ret;
  }
  return retIni;
};
